export default __webpack_public_path__ + "static/media/Phoenix_artwork.1b7d96a3.png";